/** 流程群只是消息中心的一种会话；归档状态优先于时间排序。 */
export function compareInboxConversations(left, right) {
  const archived = Number(Boolean(left.isArchived)) - Number(Boolean(right.isArchived));
  if (archived) return archived;
  const time = value => new Date(value || 0).getTime() || 0;
  return time(right.lastTime) - time(left.lastTime) || String(left.key || left.sessionId || "").localeCompare(String(right.key || right.sessionId || ""));
}
/** 私聊先复用已有联系人；首次对话用稳定双方键，点击本身不发送占位消息。 */
export function workflowPrivateConversation(currentUserId, member) {
  const ids = [String(currentUserId), String(member.userId)];
  if (!ids.every(id => /^[1-9]\d*$/.test(id))) throw new Error("Invalid private chat member");
  const sessionId = ids.sort((left, right) => BigInt(left) < BigInt(right) ? -1 : 1).join("_");
  return { kind: "LEGACY", key: `legacy:${sessionId}`, sessionId, userId: member.userId, name: member.displayName,
    messages: [], unread: 0, isUnread: false, canDelete: false, localOnly: true, lastTime: null, lastMessage: "" };
}

export function workflowInboxConversation(view, translate) {
  const group = view.group;
  const state = translate(`workflowChat.${group.state === "ARCHIVED" ? "readonly" : group.state === "COOLING" ? "cooling" : "active"}`);
  return {
    kind: "WORKFLOW_CHAT", key: `workflow-chat:${group.id}`, groupId: group.id,
    name: workflowConversationTitle(view, translate),
    lastMessage: view.lastMessage?.content || state, lastTime: view.lastMessage?.createdAt || group.updatedAt,
    mentionUnread: Number(view.mentionUnreadCount) || 0,
    unread: Number(view.unreadCount) || 0, isUnread: Number(view.unreadCount) > 0,
    isArchived: group.state === "ARCHIVED", canDelete: false, messages: [],
  };
}

/** 保留已加载页数；通知刷新不会把第 51 个群从联系人中丢掉。 */
export async function loadWorkflowInboxPages(fetchPage, pageCount = 1) {
  const rows = [];
  let hasMore = false, pages = 0;
  for (let page = 0; page < Math.max(1, pageCount); page++) {
    const batch = await fetchPage(page * 50);
    rows.push(...batch); pages++;
    hasMore = batch.length === 50;
    if (!hasMore) break;
  }
  return { rows, pages, hasMore };
}


/** 业务群名只保留简短身份、日期和流程；过滤已知验收编号，不修改原始业务标识或群绑定。 */
export function workflowConversationTitle(view, translate) {
  const displayNumber = value => {
    const number = String(value || "").trim();
    // 仅隐藏明确的测试/调试前缀，不删除正常编号中间的TEST字样。
    return /^(?:T\d+[-_])?(?:(?:AGENT|WORKFLOW|CHAT)[-_])?(?:TEST|DEBUG|FIXTURE)(?:[-_]|$)/iu.test(number) ? "" : number;
  };
  const identity = view?.identity;
  if (!identity) return displayNumber(view?.group?.businessNumber) || translate("workflowChat.discussion");
  const kind = translate(`workflowChat.${identity.orderType === "PURCHASE" ? (identity.draft ? "purchaseDraftName" : "purchaseOrderName") : (identity.draft ? "saleDraftName" : "saleOrderName")}`);
  const count = identity.orderCount > 1 ? translate("workflowChat.orderCount", { count: identity.orderCount }) : "";
  const date = /^\d{8}$/.test(identity.openedDate || "") ? identity.openedDate : "";
  const stages = (identity.stages || []).filter(stage => stage !== "PROGRESS_UNAVAILABLE").map(stage => translate(`workflowChat.progress.${stage}`));
  return [`${kind}${displayNumber(identity.orderNumber)}${count}`.trim(), date, stages.join(" / ")].filter(Boolean).join(" · ");
}
